import { render } from "./ActivitiesList.vue?vue&type=template&id=b58cff48"
import script from "./ActivitiesList.vue?vue&type=script&lang=js"
export * from "./ActivitiesList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__